import React from "react";
import { AlertCircle, Clock } from "lucide-react";
import { VEHICLE_STATUS, GENERIC_STATUS, deadlineSeverity, labelize } from "../lib/format";

// Rounded status label: a dot (or a small icon for urgent states) and the text,
// in the colours of its tone (tone-green, tone-red, ... in index.css).
export function StatusPill({ tone = "tone-slate", icon: Icon, className = "", children, ...props }) {
  return (
    <span className={`status-pill ${tone} ${className}`} {...props}>
      {Icon ? <Icon className="status-pill__icon" aria-hidden="true" /> : <span className="status-pill__dot" aria-hidden="true" />}
      <span className="truncate">{children}</span>
    </span>
  );
}

export function StatusBadge({ status, kind = "generic" }) {
  const map = kind === "vehicle" ? VEHICLE_STATUS : GENERIC_STATUS;
  const cfg = map[status];
  return <StatusPill tone={cfg ? cfg.cls : "tone-slate"} data-testid={`status-badge-${status}`}>{cfg ? cfg.label : labelize(status)}</StatusPill>;
}

export function DeadlineBadge({ expiry }) {
  const s = deadlineSeverity(expiry);
  const icon = s.sev === "scaduto" ? AlertCircle : s.sev === "in_scadenza" ? Clock : undefined;
  return <StatusPill tone={s.cls} icon={icon} data-testid={`deadline-badge-${s.sev}`}>{s.label}</StatusPill>;
}

export function AlertBadge({ type, severity }) {
  const overdue = severity === "scaduto";
  const label = type === "fermo_mezzo" ? "Da verificare" : type === "manutenzione" ? (overdue ? "In ritardo" : "Da programmare") : overdue ? "Scaduto" : severity === "in_scadenza" ? "In scadenza" : "Da verificare";
  return <StatusPill tone={overdue ? "tone-red" : "tone-amber"} icon={overdue ? AlertCircle : Clock} className="shrink-0" data-testid={`alert-badge-${type}-${severity}`}>{label}</StatusPill>;
}
